console.log('process.env', process.env)
const serverList = [
    {
        BASEURL: 'http://192.168.1.26:8403',
    },
    {
        BASEURL: 'https://julehuyu.com/gameapi',
    },
];
let serverArr;

serverArr = serverList[1]
export default serverArr
